import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import SortInput from 'components/base/sort-input';
import { Tab } from 'components/tab';
import GeneralTable from './general-table';
import EventsTable from './events-table';
import MembersTable from './members-table';

const PaymentTable = () => {
  const currentYear = new Date().getFullYear();
  const { paymentSubRoute } = useParams();
  const [filter, setFilter] = useState(String(currentYear));

  const options = [
    { name: String(currentYear) },
    { name: String(currentYear - 1) },
    { name: String(currentYear - 2) }
  ];

  const tables = [
    {
      label: 'General',
      key: 'general',
      content: <GeneralTable filter={filter} />
    },
    {
      label: 'Events',
      key: 'events',
      content: <EventsTable filter={filter} />
    },
    {
      label: 'Members',
      key: 'members',
      content: <MembersTable filter={filter} />
    }
  ];

  const defaultTable = tables.find((account) => account?.key === paymentSubRoute) ?? tables[0];

  return (
    <div className='table-auto'>
      <div className='flex justify-between items-center mt-8 payment_header'>
        <p className='font-medium my-[20px] text-[20px]'>Account Statements</p>
        <SortInput
          options={options}
          text='Filter'
          filterValue={filter}
          setFilterValue={setFilter}
        />
      </div>

      <div>
        <Tab tabs={tables} defaultSelectedTab={defaultTable} route='payment' />
      </div>
    </div>
  );
};

export default PaymentTable;
